import { hexToCSSFilter } from "hex-to-css-filter";

const BlueTheme = {
  id: 1,
  name: "BlueTheme",
  "--primary-color": "#008ecc",
  "--secondary-color": "#ef716b",
  "--faint-color": "#e2e8ff",
  "--icon-color": "#FF872C",
  "--header-color": "#f6f8fc",
  "--tabs-color": "#b3e3ff",
  "--active-tab-color": "#2d9cdb",
  "--calendar-bg-color": "#edf1fa",
  "--current-date-color": "linear-gradient(#ff872c, #ffa709)",
  "--current-slot-color": "#b6ccff",
  "--next-slot-color": "#d9e4fc",
  "--profile-card-color": "#edf1fa",
  "--outline-color": "#ef716b",
  "--profile-font-color": "#5559c4",
  "--pallet-color": "#008ecc",
  "--font-color": "#1e1c61",
  "--svg-color": hexToCSSFilter("#008ecc").filter.toString().replace(/;/g, ""),
};

const MintGreenTheme = {
  id: 2,
  name: "MintGreenTheme",
  "--primary-color": "linear-gradient(#07B0B8, #01DDBA)",
  "--secondary-color": "linear-gradient(#07B0B8, #01DDBA)",
  "--faint-color": "rgba(1, 221, 186, 0.2)",
  "--icon-color": "#FF872C",
  "--header-color": "#FAFDFD",
  "--tabs-color": "#B4E9EA",
  "--active-tab-color": "#06B6B8",
  "--calendar-bg-color": "#F8FDFD",
  "--current-date-color": "linear-gradient(#ff872c, #ffa709)",
  "--current-slot-color": "#DAEFFF",
  "--next-slot-color": "#F1F9FF",
  "--profile-card-color": "#F2F2F2",
  "--outline-color": "#07b0b8",
  "--profile-font-color": "#016E6E",
  "--pallet-color": "#07b0b8",
  "--font-color": "#1e1c61",
  "--svg-color": hexToCSSFilter("#07b0b8").filter.toString().replace(/;/g, ""),
};

const YellowTheme = {
  id: 3,
  name: "YellowTheme",
  "--primary-color": "linear-gradient(#FF872C,#FFA709)",
  "--secondary-color": "linear-gradient(#FF872C, #FFA709)",
  "--faint-color": "rgba(255, 135, 44, 0.15)",
  "--icon-color": "#EB5757",
  "--header-color": "#FFFAF3",
  "--tabs-color": "rgba(255, 137, 42, 0.4)",
  "--active-tab-color": "#F2994A",
  "--calendar-bg-color": "#FFFAF3",
  "--current-date-color": "#EF716B",
  "--current-slot-color": "#FFD1AD",
  "--next-slot-color": "#FFF2CA",
  "--profile-card-color": "#FFF5D9",
  "--outline-color": "#ff872c",
  "--profile-font-color": "#1E1C61",
  "--pallet-color": "#ff872c",
  "--font-color": "#1e1c61",
  "--svg-color": hexToCSSFilter("#ff872c").filter.toString().replace(/;/g, ""),
};

const DarkGreenTheme = {
  id: 4,
  name: "DarkGreenTheme",
  "--primary-color": "#383153",
  "--secondary-color": "#CD48F1",
  "--faint-color": "#EDE5FC",
  "--icon-color": "#FF872C",
  "--header-color": "#F5F5F6",
  "--tabs-color": "#6B6996",
  "--active-tab-color": "#383153",
  "--calendar-bg-color": "#DAD8E2",
  "--current-date-color": "linear-gradient(#ff872c, #ffa709)",
  "--current-slot-color": " rgba(87, 90, 137, 0.7)",
  "--next-slot-color": "#EDE5FC",
  "--profile-card-color": "rgba(237, 229, 252, 0.6)",
  "--outline-color": "#D76DF4",
  "--profile-font-color": "#1E1C61",
  "--pallet-color": "#383153",
  "--font-color": "#FBFBFB",
  "--svg-color": hexToCSSFilter("#383153").filter.toString().replace(/;/g, ""),
};

const GreenTheme = {
  id: 5,
  name: "GreenTheme",
  "--primary-color": "#0B655A",
  "--secondary-color": "#0B655A",
  "--faint-color": "#C9EBDE",
  "--icon-color": "#FF872C",
  "--header-color": "#EDFBFA",
  "--tabs-color": "rgba(8, 85, 76, 0.4)",
  "--active-tab-color": "#08554C",
  "--calendar-bg-color": "#AEFBFB",
  "--current-date-color": "linear-gradient(#ff872c, #ffa709)",
  "--current-slot-color": "#7EC8A6",
  "--next-slot-color": "rgba(161, 216, 192, 0.51)",
  "--profile-card-color": "#E8F5FF",
  "--outline-color": "#0B655A",
  "--profile-font-color": "#07B0B8",
  "--pallet-color": "#0b655a",
  "--font-color": "#1e1c61",
  "--svg-color": hexToCSSFilter("#0B655A").filter.toString().replace(/;/g, ""),
};

const themes = [
  MintGreenTheme,
  YellowTheme,
  DarkGreenTheme,
  GreenTheme,
  BlueTheme,
];

export const THEMES = themes;
